import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/mangaData';

export default function PopularRanking() {
  const sorted = [...mangaList].sort((a, b) => b.views - a.views).slice(0, 10);

  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading">热门排行</h2>
            <p className="text-sm text-foreground-500 mt-1">最受读者欢迎的漫画</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {sorted.map((manga, index) => (
            <Link
              key={manga.id}
              to={`/article/${manga.id}`}
              className="group flex items-center gap-4 bg-background-100 hover:bg-background-200 border border-background-300/60 hover:border-primary-500/30 rounded-lg p-3 md:p-4 transition-all duration-200 cursor-pointer"
            >
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-200 group-hover:bg-primary-500/20 transition-colors duration-200">
                <span className={`text-sm font-bold font-heading ${
                  index < 3 ? 'text-accent-500' : 'text-foreground-500'
                }`}>
                  {index + 1}
                </span>
              </div>

              <div className="w-12 h-16 md:w-14 md:h-20 flex-shrink-0 rounded overflow-hidden">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  title={`${manga.title} - h漫画排行榜`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-200 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                  {manga.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-1">{manga.author} · {manga.tags.slice(0, 2).join(' / ')}</p>
              </div>

              <div className="flex-shrink-0 text-right">
                <p className="text-sm font-semibold text-accent-500">{manga.rating}</p>
                <p className="text-xs text-foreground-600 mt-1">{(manga.views / 10000).toFixed(1)}万阅读</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}